import {
  FileTextIcon,
  FolderIcon,
  ImageIcon,
  LinkIcon,
  PaletteIcon,
  StampIcon,
  TypeIcon,
  VideoIcon,
  type LucideIcon,
} from 'lucide-react'
import type { IconoRecurso as Icono } from '@/lib/schemas/recursos'

/** Los ocho íconos fijos de un recurso (Fase 5b). No se suben imágenes propias. */
export const ICONO: Record<Icono, LucideIcon> = {
  carpeta: FolderIcon,
  marca: StampIcon,
  imagen: ImageIcon,
  video: VideoIcon,
  documento: FileTextIcon,
  tipografia: TypeIcon,
  paleta: PaletteIcon,
  enlace: LinkIcon,
}

export function IconoRecurso({ icono, className }: { icono: Icono; className?: string }) {
  const Componente = ICONO[icono]
  return <Componente className={className} aria-hidden />
}
